module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_f_albino.2c670e78.png";